import {
  AttachMoneyOutlined,
  BookmarksOutlined,
  CallSplit,
  DashboardOutlined,
  FavoriteBorder,
  Gavel,
  Group,
  HomeOutlined,
  LibraryBooksOutlined,
  PeopleOutline,
  PersonOutline,
  SchoolOutlined,
  SettingsOutlined,
  Star,
  CastForEducation,
  NewReleasesOutlined,
  BookOutlined,
  NotificationImportantOutlined,
  Notifications,
  Link,
  StarBorderOutlined,
} from '@material-ui/icons';
import SportsEsportsOutlinedIcon from '@material-ui/icons/SportsEsportsOutlined';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import FindInPageOutlinedIcon from '@material-ui/icons/FindInPageOutlined';
import TimelineOutlinedIcon from '@material-ui/icons/TimelineOutlined';
import LoyaltyOutlinedIcon from '@material-ui/icons/LoyaltyOutlined';
import SettingsOverscanIcon from '@material-ui/icons/SettingsOverscan';
import BuildOutlinedIcon from '@material-ui/icons/BuildOutlined';
import CastForEducationOutlinedIcon from '@material-ui/icons/CastForEducationOutlined';
import CategoryOutlinedIcon from '@material-ui/icons/CategoryOutlined';
import CreateOutlinedIcon from '@material-ui/icons/CreateOutlined';
import GroupAddOutlinedIcon from '@material-ui/icons/GroupAddOutlined';
import LocalOfferOutlinedIcon from '@material-ui/icons/LocalOfferOutlined';
import PeopleAltOutlinedIcon from '@material-ui/icons/PeopleAltOutlined';
import VerifiedUserOutlinedIcon from '@material-ui/icons/VerifiedUserOutlined';
import LayersOutlinedIcon from '@material-ui/icons/LayersOutlined';

import React from 'react';
import { useTranslation } from 'react-i18next';

const Translate = ({ text }) => {
  const { t } = useTranslation(['menu']);
  return <React.Fragment><span className='notranslate'>{t(text)}</span></React.Fragment>;
};

export default [
  {
    title: <Translate text={'menu:sidebar.admin.dashboard_menu.dashboard'} />,
    href: '#',
    icon: <HomeOutlined />,
    subitems: [
      {
        title: (
          <Translate text={'menu:sidebar.admin.dashboard_menu.news'} />
        ),
        href: '/dashboard',
        icon: < NewReleasesOutlined />,
      },
      {
        title: (
          <Translate text={'menu:sidebar.admin.dashboard_menu.subplatform'} />
        ),
        href: '/companies',
        icon: <DashboardOutlined />,
      },
      {
        title: (
          <Translate text={'menu:sidebar.admin.dashboard_menu.academy_ia'} />
        ),
        href: '/academyia',
        icon: <LayersOutlinedIcon />,
      },
    ],
  },
  {
    title: <Translate text={'menu:sidebar.admin.users_menu.users'} />,
    href: '#',
    icon: <PeopleOutline />,
    subitems: [
      {
        title: (
          <Translate text={'menu:sidebar.admin.users_menu.users_manager'} />
        ),
        href: '/users',
        permission: 'users',
        icon: <PersonOutline />,
      },
      // {
      //   title: <Translate text={'menu:sidebar.admin.users_menu.users_group'} />,
      //   href: '/groups',
      //   icon: <PeopleAltOutlinedIcon />,
      // },
      {
        title: <Translate text={'menu:sidebar.admin.users_menu.requests'} />,
        href: '/user-solicitations',
        permission: 'user_solicitations',
        icon: <GroupAddOutlinedIcon />,
      },
      {
        title: <Translate text={'menu:sidebar.admin.users_menu.teams'} />,
        href: '/teams',
        permission: 'teams',
        icon: <Group />,
      },
    ],
  },
  {
    title: <Translate text={'menu:sidebar.admin.courses_menu.education'} />,
    href: '#',
    icon: <SchoolOutlined />,
    subitems: [
      {
        title: <Translate text={'menu:sidebar.admin.courses_menu.courses'} />,
        href: '/courses/manage',
        permission: 'courses',
        icon: <CastForEducationOutlinedIcon />,
      },
      {
        title: (
          <Translate text={'menu:sidebar.admin.courses_menu.categories'} />
        ),
        href: '/categories',
        permission: 'categories',
        icon: <CategoryOutlinedIcon />,
      },
      {
        title: (
          <Translate text={'menu:sidebar.admin.courses_menu.subcategories'} />
        ),
        href: '/subcategories',
        permission: 'subcategories',
        icon: <BookmarksOutlined />,
      },
      {
        title: <Translate text={'menu:sidebar.admin.courses_menu.trails'} />,
        href: '/trails',
        permission: 'trails',
        icon: <CallSplit />,
      },
      {
        title: <Translate text={'menu:sidebar.admin.courses_menu.library'} />,
        href: '/library',
        permission: 'library',
        icon: <LocalOfferOutlinedIcon />,
      },
      {
        title: <Translate text={'menu:sidebar.admin.courses_menu.classroom'} />,
        href: '/classroomcourses/manage',
        permission: 'classroom_courses',
        icon: <BookOutlined />,
      },
      // {
      //   title: <Translate text={'menu:sidebar.admin.courses_menu.tags'} />,
      //   href: '/tags',
      //   icon: <LocalOfferOutlinedIcon />,
      // },
    ],
  },
  {
    title: <Translate text={'Gamificação'} />,
    href: '#',
    icon: <SportsEsportsOutlinedIcon />,
    subitems: [
      {
        title: <Translate text={'Configurações'} />,
        href: '/gamification/settings',
        permission: 'gamification_settings',
        icon: <SettingsOverscanIcon />,
      },
      {
        title: <Translate text={'Gestão de Recompensas'} />,
        href: '/gamification/rewards',
        permission: 'gamification_rewards',
        icon: <LoyaltyOutlinedIcon />,
      },
      {
        title: <Translate text={'Gestão de Pontos'} />,
        href: '/gamification/points',
        permission: 'gamification_points',
        icon: <TimelineOutlinedIcon />,
      },
      {
        title: <Translate text={'Relatórios de Resgate'} />,
        href: '/gamification/reports',
        permission: 'gamification_reports',
        icon: <FindInPageOutlinedIcon />,
      },
      {
        title: <Translate text={'Ranking'} />,
        href: '/gamification/ranking',
        permission: 'gamification_ranking',
        icon: <EqualizerIcon />,
      },
      {
        title: <Translate text={'Notificações'} />,
        href: '/gamification/notifications',
        permission: 'gamification_notifications',
        icon: <Notifications />,
      },
    ],
  },
  {
    title: <Translate text={'menu:sidebar.admin.reports_menu.reports'} />,
    href: '#',
    icon: <LibraryBooksOutlined />,
    subitems: [
      // {
      //   title: <Translate text={'menu:sidebar.admin.reports_menu.dashboard'} />,
      //   href: '/admin-dashboard',
      //   icon: <DashboardOutlined />,
      // },
      {
        title: (
          <Translate text={'menu:sidebar.admin.reports_menu.dashboard'} />
        ),
        href: '/admin-dashboard',
        permission: 'reports_dashboard',
        icon: <DashboardOutlined />,
      },
      {
        title: <Translate text={'menu:sidebar.admin.reports_menu.academic'} />,
        href: '/reports/academic',
        permission: 'reports_academic',
        icon: <SchoolOutlined />,
      },
      {
        title: <Translate text={'menu:sidebar.admin.reports_menu.users'} />,
        href: '/reports/companies-users',
        permission: 'reports_users',
        icon: <PersonOutline />,
      },
      {
        title: <Translate text={'menu:sidebar.admin.reports_menu.trails'} />,
        href: '/reports/companies-trails',
        permission: 'reports_trails',
        icon: <CallSplit />,
      },
      {
        title: <Translate text={'menu:sidebar.admin.reports_menu.attendance'} />,
        href: '/reports/companies-attendance',
        permission: 'reports_attendance',
        icon: <BookOutlined />,
      },
      {
        title: <Translate text={'Avaliações ⭐️'} />,
        href: '/reports/ratings',
        permission: 'reports_ratings',
        icon: <StarBorderOutlined />,
      },
      {
        title: <Translate text={'menu:sidebar.admin.settings_menu.lgpd'} />,
        href: '/reports/lgpd',
        permission: 'reports_lgpd',
        icon: <Gavel />,
      },
    ],
  },

  // {
  //   title: <Translate text={'menu:sidebar.admin.custom_menu'} />,
  //   href: '/settings/company-customization',
  //   icon: <FavoriteBorder />,
  // },
  {
    title: <Translate text={'menu:sidebar.admin.settings_menu.settings'} />,
    href: '#',
    icon: <SettingsOutlined />,
    subitems: [
      {
        title: <Translate text={'menu:sidebar.admin.settings_menu.general'} />,
        href: '/settings/general',
        permission: 'settings_general',
        icon: <BuildOutlinedIcon />,
      },
      // {
      //   title: <Translate text={'menu:sidebar.admin.settings_menu.communication'} />,
      //   href: '/settings/communication',
      //   icon: <Notifications />,
      // },
      {
        title: (
          <Translate text={'menu:sidebar.admin.settings_menu.certificate'} />
        ),
        href: '/settings/certificate',
        permission: 'settings_certificate',
        icon: <VerifiedUserOutlinedIcon />,
      },
      {
        title: (
          <Translate text={'menu:sidebar.admin.settings_menu.edit_fields'} />
        ),
        href: '/settings/custom-fields',
        permission: 'settings_custom_fields',
        icon: <CreateOutlinedIcon />,
      },
      {
        title: <Translate text={'menu:sidebar.admin.settings_menu.featured'} />,
        href: '/settings/featured-courses',
        permission: 'settings_featured',
        icon: <Star />,
      },
      {
        title: <Translate text={'Integrações'} />,
        href: '/settings/integrations',
        permission: 'settings_integrations',
        icon: <Link />,
      },
      {
        title: <Translate text={'menu:sidebar.admin.settings_menu.lgpd'} />,
        href: '/settings/lgpd',
        permission: 'settings_lgpd',
        icon: <Gavel />,
      },
    ],
  },
  {
    title: 'Produção de conteúdos',
    href: '/production',
    permission: 'content_production',
    icon: <CastForEducation />,
  },
];
